import InfoBoxes from './InfoBoxes';

export default InfoBoxes;
